import { readNfcAndroid, writeNfcAndroid } from '../Android/actions';

export function readNfcCard() {
  readNfcAndroid();
}

export function writeNfcCard({ cardToken, meterSerial }) {
  writeNfcAndroid({ cardToken, meterSerial });
}
